import type { Theme } from '@emotion/react';
import { FormattedMessage } from 'react-intl';

import messages from './Select.messages';

export const DEFAULT_DEBOUNCE_TIME_MS = 300;

export enum SELECT_SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type MakeCustomThemeProps = {
  theme: Theme;
  hasError: boolean;
  hasWarning: boolean;
  size: SELECT_SIZES;
};

export type MakeCustomStylesProps = {
  theme: Theme;
  hasError: boolean;
  hasWarning: boolean;
  size: SELECT_SIZES;
  isInLayer: boolean;
  layerZIndex?: number;
};

export type CommonSelectProps = {
  size?: SELECT_SIZES;
  disabled?: boolean;
  hasError?: boolean;
  hasWarning?: boolean;
};

export const PLACEHOLDER_DEFAULT_VALUE = <FormattedMessage {...messages.PLACEHOLDER} />;

export const NO_OPTIONS_MESSAGE = ({ inputValue }: { inputValue: string }) => (
  <FormattedMessage {...messages.NO_OPTIONS} values={{ inputValue, hasValue: !!inputValue }} />
);

export const LOADING_MESSAGE = () => <FormattedMessage {...messages.LOADING} />;

export const CREATABLE_SELECT_DEFAULT_VALUE = (inputValue?: string) => (
  <FormattedMessage
    {...messages.CREATE_VALUE}
    values={{
      inputValue,
    }}
  />
);
